import { MNEMONICS } from 'constants/mnemonics';
import { MnemonicMappingDTO } from 'types/mnemonicsMapping';

export const getActiveOrMostRecentTriptankMnemonic = (
  kickDetectionMnemonicsMapping: MnemonicMappingDTO,
): string | null => {
  const triptank1Live = kickDetectionMnemonicsMapping[MNEMONICS.TTVOL01]?.live;
  const triptank2Live = kickDetectionMnemonicsMapping[MNEMONICS.TTVOL02]?.live;

  if (triptank1Live === undefined && triptank2Live === undefined) {
    return null;
  }

  let triptankMnemonic;
  if (triptank1Live === undefined || (!triptank1Live && triptank2Live)) {
    triptankMnemonic = MNEMONICS.TTVOL02;
  } else if (triptank2Live === undefined || (!triptank2Live && triptank1Live)) {
    triptankMnemonic = MNEMONICS.TTVOL01;
  } else {
    triptankMnemonic =
      kickDetectionMnemonicsMapping[MNEMONICS.TTVOL01].lastMeasureTime >
      kickDetectionMnemonicsMapping[MNEMONICS.TTVOL02].lastMeasureTime
        ? MNEMONICS.TTVOL01
        : MNEMONICS.TTVOL02;
  }

  return triptankMnemonic;
};

export const getActiveTriptankMnemonicFromLiveData = (
  mnemonicsLastTimestamp: Record<string, string>,
): string | null => {
  if (mnemonicsLastTimestamp[MNEMONICS.TVOL01] && mnemonicsLastTimestamp[MNEMONICS.TVOL02]) {
    return mnemonicsLastTimestamp[MNEMONICS.TTVOL01] > mnemonicsLastTimestamp[MNEMONICS.TTVOL02]
      ? MNEMONICS.TVOL01
      : MNEMONICS.TVOL02;
  }
  if (mnemonicsLastTimestamp[MNEMONICS.TVOL01]) {
    return MNEMONICS.TTVOL01;
  }
  if (mnemonicsLastTimestamp[MNEMONICS.TTVOL02]) {
    return MNEMONICS.TTVOL02;
  }

  return null;
};
